import { Component, OnInit } from '@angular/core';

import { combineLatest, Observable } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';

import AuthenticationFacade from '@app/core/facades/authentication.facade';
import StudentFacade from '@app/core/facades/student.facade';
import { LaunchDarklyState } from '@app/core/states/launch-darkly/launch-darkly.state';
import { FilterType } from '@app/shared/components/sub-header/filter-type.model';
import FilterChange from '@app/shared/filters/filter-change.model';
import { FilterOptions } from '@app/shared/filters/filter-options.interface';
import FilterComponent from '@app/shared/filters/filter.component';

const SIZE = '240px';
const STUDENT_ICONS = 'student-picker-school-icon';

@Component({
  selector: 'app-filter-student',
  templateUrl: '../filter.component.html',
  styleUrls: ['../filter.component.scss'],
})
export default class StudentFilterComponent extends FilterComponent implements OnInit {
  public readonly label = 'Student';
  public options$ = combineLatest([
    this._data.studentsFiltered$,
    this._data.schools$,
    this._auth.isAdmin$,
    this._auth.isGuide$,
    this._launchDarkly.flags$,
  ]).pipe(
    map(([students, schools, isAdmin, isGiude, flags]) => {
      const options: { [key: string]: unknown }[] = students.map((student) => {
        let showLogo = false;
        let schoolLogo = null;

        if (isAdmin || isGiude) {
          const foundSchool = schools.find((school) => student.schoolId === school.id);
          if (foundSchool) {
            const schoolName = (foundSchool.name || '').toLowerCase().trim().replace(' ', '-');
            schoolLogo = foundSchool.schoolIcon || null;
            showLogo = (flags[STUDENT_ICONS] as { [key: string]: unknown })[schoolName] as boolean;
          }
        }

        return {
          ...student,
          logoUrl: showLogo ? schoolLogo : null,
        };
      });
      return options as FilterOptions[];
    })
  );

  public defaultValue$: Observable<FilterOptions>;

  public update(value: string, _: boolean): void {
    this._data.updateStudentId(value);
    this.valueChange.emit(new FilterChange(FilterType.Student, value));
  }

  public readonly width = SIZE;

  constructor(
    private readonly _data: StudentFacade,
    private readonly _launchDarkly: LaunchDarklyState,
    private readonly _auth: AuthenticationFacade
  ) {
    super();
  }

  ngOnInit() {
    this.options$ = (!!this.config.transform ? this.config.transform(this.options$) : this.options$).pipe(
      distinctUntilChanged(),
      map((options: Array<{ [key: string]: string | number }>) =>
        options.map((option) => ({
          ...option,
          value: option.studentId,
          label: `${option.preferredName || option.firstName} ${option.lastName}`,
        }))
      )
    );

    this.initDefaultValues(this._data.studentId$);
  }
}
